export default __webpack_public_path__ + "static/media/videoJd3.3dc205b9.mp4";